<div class="row">
    <div class="col-12 col-lg-12">
        <h1
            [innerHTML]="title | bypassSecurity: 'html'"
            class="resource-title selenium-resource-title {{ mediaTypeClass }}"
        ></h1>
    </div>
</div>
<div
    [ngClass]="{ 'mb-md-4': !userService.hasStudentExperience() }"
    class="row-auto d-flex flex-wrap justify-content-between mb-1 mt-4"
>
    <div
        [ngClass]="{
            'col-lg-8': !resourceService.focusView && !userService.hasStudentExperience(),
            'col-lg-12': userService.hasStudentExperience(),
        }"
        class=" col-12 mb-2 {{ mediaTypeClass }} d-flex flex-wrap"
    >
        <div class="mb-1">
            <span class="selenium-resource-type me-6">
                <app-icon title="{{ mediaTypeTitle }}" type="{{ mediaTypeTitle }}"></app-icon>
                {{ mediaTypeTitle }}
            </span>

            <span *ngIf="gradesDisplay" class="selenium-resource-grades me-6">
                Grades: {{ gradesDisplay }}
            </span>
            <app-collections-dropdown
                *ngIf="primaryCollection && !isAddonView"
                [linksOptions]="linksOptions"
                [primaryCollection]="primaryCollection"
                class="me-6"
            ></app-collections-dropdown>
            <span *ngIf="primaryCollection && isAddonView" class="collection-title">
                Collection:
                <span [class]="isAddonView ? 'color-gray' : null">{{
                    primaryCollection.title
                }}</span>
            </span>
            <span *ngIf="contentProject && contentProject.title" class="byline-wrapper ms-4">
                {{ contentProject.label }}:
                <span *ngIf="!contentProject.url" class="byline"
                    >{{ contentProject.title }} {{ contentProject.byline }}</span
                >
                <app-link
                    *ngIf="contentProject.url && !isAddonView"
                    [appRouterLink]="contentProject.url"
                    [title]="contentProject.title"
                    class="byline selenium-resource-subtitle-byline gtm-resource-subtitle-byline"
                >
                    {{ contentProject.title }} {{ contentProject.byline }}
                </app-link>
                <span *ngIf="isAddonView" class="color-gray fw-bold">
                    {{ contentProject.title }} <span>{{ contentProject.byline }}</span></span
                >
            </span>
            <span *ngIf="resourceExpiresInNext18Months" class="d-inline-block me-2">
                Resource Expires:
                <span class="expiration-date fw-bold"
                    >{{ resourceExpirationDate | date: "MM/dd/yyyy" }}
                </span>
            </span>
        </div>

        <div
            *ngIf="userService.hasStudentExperience()"
            [ngClass]="{
                'student-experience': this.userService.isLoggedIn(),
            }"
            class="additional-options"
        >
            <div class="fav-icon-container">
                <div class="row-auto g-0 icons-group subtitle-fav-icon mt-3">
                    <app-favorite-button
                        *ngIf="!isAddonView"
                        [disable]="!favoriteId || (isInPreviewMode$ | async)"
                        [learningObjectId]="favoriteId"
                        class="share-resource-item mb-4"
                        hideLabelOnMobile="true"
                        hideLabelOnSmallDevices="true"
                        hideLabelOnTablet="true"
                        loggedinTooltip="Save this resource for later."
                        loggedoutTooltip="Sign in or create an account to add this resource to your Favorites. "
                    >
                    </app-favorite-button>
                </div>
            </div>

            <div
                *ngIf="userService.isLoggedIn() && !userService.isStudent() && isTeacherPreview"
                class="col-12 col-lg-4 mb-lg-0 ps-lg-0 experience-toggle"
            >
                <app-experience-toggle
                    [canSwitchToStudentExperience]="isAvailableToStudents"
                    [isFocusView]="resourceService.focusView"
                ></app-experience-toggle>
            </div>

            <span
                *ngIf="!userService.isLoggedIn() && !isAddonView"
                class="mb-2 mb-lg-0 redirect-button"
            >
                <button (click)="teacherLogin()" class="btn btn-primary">
                    Teachers, sign in for resources
                </button>
            </span>
        </div>
    </div>
    <div
        *ngIf="
            userService.isLoggedIn() &&
            !userService.hasStudentExperience() &&
            !resourceService.focusView &&
            isTeacherPreview
        "
        class="col-12 col-lg-4 mb-4 mt-n-3 mb-lg-0 ps-lg-0 full-experience-toggle"
    >
        <app-experience-toggle
            [canSwitchToStudentExperience]="isAvailableToStudents"
        ></app-experience-toggle>
    </div>
</div>
